import { animate, AnimationTriggerMetadata, state, style, transition, trigger } from '@angular/animations';

import { IAnimationOptions } from '../_interfaces/animate.interface';

const DEFAULT_DURATION = 0;

export function fadeInOutAnimation(options?: IAnimationOptions): AnimationTriggerMetadata {
  return trigger((options && options.anchor) || 'fadeInOut', [
    state(
      '0',
      style({
        opacity: 0,
        pointerEvents: 'none',
        maxHeight: 0,
        border: 'none',
        paddingTop: 0,
        paddingBottom: 0,
        transition: 'padding 0.2ms ease-out'
      })
    ),
    state(
      '1',
      style({
        opacity: 1,
        pointerEvents: 'auto',
        maxHeight: 'none'
      })
    ),
    transition('0 => 1', [animate('{{durationIn}}ms {{delayIn}}ms')], {
      params: {
        delayIn: (options && options.delayIn) || 0,
        durationIn: (options && options.durationIn) || DEFAULT_DURATION
      }
    }),
    transition('1 => 0', [animate('{{durationOut}}ms {{delayOut}}ms')], {
      params: {
        delayOut: (options && options.delayOut) || 0,
        durationOut: (options && options.durationOut) || DEFAULT_DURATION
      }
    })
  ]);
}
